import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Styles from './style.module.scss';
import PricingPlansFilterPlanButton from './PricingPlansFilterPlanButton';
import PricingPlansFilterLayoutButton from './PricingPlansFilterLayout';
import withComponentName from '../../../../../../decorators/withComponentName';

const cx = classNames.bind(Styles);

export const PricingPlansFilter = ({
  activePlanTab, activeLayoutTab, handleLayoutChange, handlePlanChange,
}) => (
  <>
    <div className={cx('PricingPlans__filter_type')}>
      <div className={cx('PricingPlans__tabs')}>
        <PricingPlansFilterPlanButton
          btnID="noncommercial"
          btnText="Non-Commercial Plans"
          isActive={activePlanTab === 'noncommercial'}
          handleBtnClick={handlePlanChange}
        />
        <PricingPlansFilterPlanButton
          btnID="commercial"
          btnText="Commercial Plans"
          isActive={activePlanTab === 'commercial'}
          handleBtnClick={handlePlanChange}
        />
      </div>
    </div>
    <div className={cx('PricingPlans__filter_view')}>
      <span className={cx('PricingPlans__filter_view__title')}>Layout:</span>
      <PricingPlansFilterLayoutButton
        btnID="detailed"
        btnText="Detailed"
        isActive={activeLayoutTab === 'detailed'}
        handleBtnClick={handleLayoutChange}
      />
      <PricingPlansFilterLayoutButton
        btnID="column"
        btnText="Column"
        isActive={activeLayoutTab === 'column'}
        handleBtnClick={handleLayoutChange}
      />
    </div>
  </>
);

PricingPlansFilter.propTypes = {
  activePlanTab: PropTypes.string.isRequired,
  activeLayoutTab: PropTypes.string.isRequired,
  handleLayoutChange: PropTypes.func.isRequired,
  handlePlanChange: PropTypes.func.isRequired,
};

export default withComponentName(PricingPlansFilter);
